const appConfig = {
  language: "fr",
  name: 'Dropcv',
  logoImage: require('@src/assets/images/logo/logo.svg').default,
}

// export const cookieName = appConfig.cookie.name

export default appConfig